import { fetch } from 'wix-fetch';

export async function getLoggedInUser() {
	let loggedIn;
	const url = `https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails`;
	let results = await fetch(url).then(
		async (response) => {
			if (response.status !== 200) {
				Promise.reject('Problem in fetching')
			}
			await response.text().then((data) => {
				const values = data
				values.indexOf('"success":true') === -1 ? loggedIn = false : loggedIn = true;
				Promise.resolve(loggedIn)
			});
		});
	return loggedIn;
}

export async function getUserCountry(lat, long) {
    // try {
    //     let result = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${lat}${long}&key=AIzaSyDhRrld6IzaXHgx0wW7b0BwASqvq-Od8vQ`)
    //     return result;
    // } catch (err) {
    //     return err
    // }

	return fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=AIzaSyBpZ6f9HdkWgLMKlm5aLWWuVBpK8Wyrty8`)
	.then( (httpResponse) => {
    if (httpResponse.ok) {
      return httpResponse.json();
    } else {
      return Promise.reject("Fetch did not succeed");
    }
  } )
//   .then(json => console.log(json, "public"))
  .catch(err => console.log(err));

}